import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { format } from "date-fns";
import Text from "../../utils/commonComponent/Custom/text";
import CommonForm from "../../utils/commonComponent/commonForm";
import {
  CancelButton,
  SaveAndUpdate,
  UploadButton,
} from "../../utils/commonComponent/Custom/Button";
import {
  fetchCountOfTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL, employeeUnicode } from "../../global";
import EditableTable from "../../utils/commonComponent/editableTable";
import LoaderModal from "../../utils/loader.js/loader";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";
import moment from "moment";
import EmployeeExcelUpload from "./employeeExcelUpload";
import { TextFields, DateInput } from "../../utils/commonComponent/Custom/custominput";
import {
  branchOptions,
  departmentOptions,
  designationOptions,
  HR_employeeStatus,
  nablDesignationOptions,
} from "./employeeConstants";

const employeeQualificationInputFields = [
  { type: "Textarea", label: "SSC School Name ", stateKey: "SSCName" },
  { type: "Textarea", label: "SSC Percentage ", stateKey: "SSCPercentage" },
  { type: "Textarea", label: "SSC Passing Year ", stateKey: "SSCPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "SSC Marksheet ",
    stateKey: "SSCMarksheetUrl",
    label: "SSC Marksheet ",
    downloadFile: true,
  },
  { type: "Textarea", label: "HSC/Diploma College Name ", stateKey: "HSCName" },
  {
    type: "Textarea",
    label: "HSC/Diploma Percentage ",
    stateKey: "HSCPercentage",
  },
  {
    type: "Textarea",
    label: "HSC/Diploma Passing Year ",
    stateKey: "HSCPassyear",
  },
  {
    type: "ImageUpload",
    tooltipLabel: "HSC/Diploma Marksheet ",
    stateKey: "HSCMarksheetUrl",
    label: "HSC/Diploma Marksheet ",
    downloadFile: true,
  },
  {
    type: "Textarea",
    label: "Graduation College Name ",
    stateKey: "GraduationName",
  },
  {
    type: "Textarea",
    label: "Graduation Percentage ",
    stateKey: "GraduationPercentage",
  },
  {
    type: "Textarea",
    label: "Graduation Passing Year ",
    stateKey: "GraduationPassyear",
  },
  {
    type: "ImageUpload",
    tooltipLabel: "Graduation Marksheet ",
    stateKey: "GraduationMarksheetUrl",
    label: "Graduation Marksheet ",
    downloadFile: true,
  },
  { type: "Textarea", label: "PG College Name", stateKey: "PGName" },
  { type: "Textarea", label: "PG Percentage", stateKey: "PGPercentage" },
  { type: "Textarea", label: "PG Passing Year", stateKey: "PGPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "PG Marksheet",
    stateKey: "PGMarksheetUrl",
    label: "PG Marksheet",
    downloadFile: true,
  },
  { type: "Textarea", label: "PhD College Name", stateKey: "PhDName" },
  { type: "Textarea", label: "PhD Percentage", stateKey: "PhDPercentage" },
  { type: "Textarea", label: "PhD Passing Year", stateKey: "PhDPassyear" },
  {
    type: "ImageUpload",
    tooltipLabel: "PhD Marksheet ",
    stateKey: "PhDMarksheetUrl",
    label: "PhD Marksheet ",
    // downloadFile: true,
  },
];

const employeeNomineeInputFields = [
  {
    type: "Textarea",
    label: "Nominee Name",
    stateKey: "nomineeName",
  },
  {
    type: "phoneNo",
    label: "Contact Number",
    stateKey: "nomineeContactNumber",
  },

  {
    type: "Autocomplete",
    label: "Relationship",
    stateKey: "relationship",
    options: [
      { id: 1, name: "Father" },
      { id: 2, name: "Mother" },
      { id: 3, name: "Husband" },
      { id: 4, name: "Wife" },
      { id: 5, name: "Son" },
      { id: 6, name: "Daughter" },
      { id: 7, name: "Brother" },
      { id: 8, name: "Sister" },
    ],
    valueKey: "name",
    getOptionLabelKey: "name",
  },
  { type: "emailId", label: "Email", stateKey: "NomineeEmailId" },
];

const employeeDocumentInputFields = [
  { type: "Textarea", label: "Aadhar ID ", stateKey: "aadharId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Aadhar Card ",
    stateKey: "aadharUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "PAN ID ", stateKey: "panId" },
  {
    type: "ImageUpload",
    tooltipLabel: "PAN Card ",
    stateKey: "panUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Passport ID", stateKey: "passportId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Passport ",
    stateKey: "passportUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Driver Licence ID", stateKey: "driverLicenceId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Driver Licence ",
    stateKey: "driverLicenseUlr",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Bank Name ", stateKey: "bankName" },
  {
    type: "Textarea",
    label: "Bank Account Number ",
    stateKey: "bankAccountNumber",
  },
  { type: "Textarea", label: "IFSC Code ", stateKey: "ifscCode" },
  {
    type: "ImageUpload",
    tooltipLabel: "Cancel cheque ",
    stateKey: "cancelCheckUrl",
    label: "",
    downloadFile: true,
  },
  { type: "Textarea", label: "Voter ID ", stateKey: "voterId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Voter ID",
    stateKey: "voterIdUlr",
    label: "",
    downloadFile: true,
  },
];

const employeeEmergencyDetailsInputFields = [
  {
    type: "Textarea",
    label: "Contact Person Name ",
    stateKey: "contactPersonName",
  },
  {
    type: "phoneNo",
    label: "Contact Number ",
    stateKey: "emergencyContactNumber",
  },

  {
    type: "phoneNo",
    label: "Alternative Contact Number ",
    stateKey: "emergencyAlternativeContactNumber",
  },
  { type: "emailId", label: "Email ", stateKey: "emergencyEmailId" },
  {
    type: "ImageUpload",
    tooltipLabel: "Aadhar ",
    stateKey: "emergencyAadharUrl",
    label:  "Aadhar ",
    downloadFile: true,
  }, //aadharUrl
];

const initialColumns = [
  {
    id: "dependentName",
    label: "Dependent Name",
    accessor: "dependentName",
    dataType: "text",
  },
  {
    id: "relationship",
    label: "Relationship",
    accessor: "relationship",
    dataType: "text",
  },
  {
    id: "companyName",
    label: "Company Name",
    accessor: "companyName",
    dataType: "text",
  },
  {
    id: "policyNumber",
    label: "Policy Number",
    accessor: "policyNumber",
    dataType: "text",
  },
  {
    id: "fromDate",
    label: "From Date",
    accessor: "fromDate",
    dataType: "text",
  },
  {
    id: "toDate",
    label: "To Date",
    accessor: "toDate",
    dataType: "text",
  },
];

const EditEmployeeMaster = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});
  const [beforeCalibrationData, setBeforeCalibrationData] = useState([]);
  const [experienceData, setExperienceData] = useState([]); // NEW: For multiple experience entries
  const [employeeCount, setEmployeeCount] = useState(0);
  const [deletedRowIds, setDeletedRowIds] = useState([]);
  const [deletedExperienceIds, setDeletedExperienceIds] = useState([]); // NEW: Track deleted experience rows
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const _userType = Number(localStorage.getItem("type"));

  const inputFields = [
    {
      type: "TextField",
      label: "Employee Code *",
      stateKey: "employeesCode",
      disabled: true,
    },
    { type: "TextField", label: "Name *", stateKey: "name" },

    {
      type: "Textarea",
      label: "Permanent Address *",
      stateKey: "permenantAddress",
    },
    {
      type: "Textarea",
      label: "Current Address *",
      stateKey: "currentAddress",
    },

    {
      type: "DatePicker",
      label: "Date Of Birth *",
      stateKey: "dateOfBirth",
      disableFutureDates: true,
    },
    {
      type: "DatePicker",
      label: "Date Of Joining *",
      stateKey: "dateOfJoining",
      disabled: ![1, 2, 8].includes(_userType),
    },
    { type: "phoneNo", label: "Contact Number *", stateKey: "contactNumber" },
    {
      type: "phoneNo",
      label: "Alternative Contact Number *",
      stateKey: "alternativeContactNumber",
    },
    { type: "emailId", label: "Email Address *", stateKey: "emailAddress" },
    {
      type: "emailId",
      label: "office Email Address *",
      stateKey: "officeEmailAddress",
    },

    {
      type: "Autocomplete",
      label: "Gender *",
      stateKey: "gender",
      options: [
        { id: 1, name: "Male" },
        { id: 2, name: "Female" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },

    {
      type: "Autocomplete",
      label: "Blood Group *",
      stateKey: "bloodGroup",
      options: [
        { id: 1, name: "A+" },
        { id: 2, name: "A-" },
        { id: 3, name: "B+" },
        { id: 4, name: "B-" },
        { id: 5, name: "AB+" },
        { id: 6, name: "AB-" },
        { id: 7, name: "O+" },
        { id: 8, name: "O-" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    {
      type: "Autocomplete",
      label: "Marital Status *",
      stateKey: "maritalStatus",
      options: [
        { id: 1, name: "Married" },
        { id: 2, name: "Unmarried" },
      ],
      valueKey: "name",
      getOptionLabelKey: "name",
    },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchEmployeesDetails = async () => {
    try {
      const [employee] = await fetchQuery(
        `SELECT * FROM employees WHERE id = ${params.id}`,
      );

      const detailTables = [
        "employeeQualification",
        "employeeNominee",
        "employeeEmergencyDetails",
        "employeeOtherData",
        "employeeDocuments",
      ];

      const results = await Promise.all(
        detailTables.map((table) =>
          fetchQuery(`SELECT * FROM ${table} WHERE employeeId = ${params.id}`),
        ),
      );

      const mergedData = { ...employee };

      detailTables.forEach((table, index) => {
        const record = results[index][0];
        if (record) {
          Object.entries(record).forEach(([key, value]) => {
            if (key === "id") {
              mergedData[`${table}Id`] = value;
            } else if (!(key in mergedData)) {
              mergedData[key] = value;
            }
          });
        }
      });

      // NEW: Fetch all experience records
      const experienceRecords = await fetchQuery(
        `SELECT * FROM employeeExperience WHERE employeeId = ${params.id}`
      );
      
      if (experienceRecords && experienceRecords.length > 0) {
        setExperienceData(experienceRecords);
        mergedData.isExperienced = 2;
      } else {
        mergedData.isExperienced = 1;
        setExperienceData([]);
      }

      if (mergedData.dependentCoveredDetails) {
        let parsedDetails = [];
        try {
          parsedDetails = JSON.parse(mergedData.dependentCoveredDetails) || [];
        } catch (err) {
          console.error("Error parsing dependentCoveredDetails:", err);
          parsedDetails = [];
        }
        setBeforeCalibrationData(parsedDetails);
        delete mergedData.dependentCoveredDetails;
      } else {
        setBeforeCalibrationData([]); // fallback empty array
      }

      setInputStates(mergedData);
    } catch (error) {
      console.error("Error fetching employee details:", error);
    }
  };

  const employeeExperienceInputFields = [
    {
      type: "Autocomplete",
      label: "Is Experienced *",
      stateKey: "isExperienced",
      options: [
        { id: 1, name: "Fresher" },
        { id: 2, name: "Experienced" },
      ],
      valueKey: "id",
      getOptionLabelKey: "name",
    },
  ];

  const onlyForHrInputFields = [
    {
      type: "Autocomplete",
      label: "Designation",
      stateKey: "hrDesignation",
      options: designationOptions.sort((a, b) => a.name.localeCompare(b.name)),
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "NABL Designation",
      stateKey: "nablDesignation",
      options: nablDesignationOptions.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Department",
      stateKey: "department",
      options: departmentOptions?.sort((a, b) => a.name.localeCompare(b.name)),
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },

    {
      type: "Autocomplete",
      label: "Reporting Manager",
      stateKey: "reportingManagerId",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Manager",
      stateKey: "appprovalManagerId",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Level 1",
      stateKey: "approvalLevel1Id",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Approval Level 2",
      stateKey: "approvalLevel2Id",
      options: "employees",
      valueKey: "id",
      getOptionLabelKey: "name",
      optionsFilter: "where status = 1",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Branch",
      stateKey: "branchId",
      options: branchOptions,
      valueKey: "name",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Autocomplete",
      label: "Status",
      stateKey: "employeeStatus",
      options: HR_employeeStatus,
      valueKey: "id",
      getOptionLabelKey: "name",
      disabled: ![1, 2, 8].includes(_userType),
    },
    // {
    //   type: "emptySpace",
    //   stateKey: "",
    // },
    {
      type: "Checkbox",
      label: "PF Number",
      stateKey: "isPfNumber",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Checkbox",
      label: "ESIC Number",
      stateKey: "isEsicNumber",
      disabled: ![1, 2, 8].includes(_userType),
    },
    {
      type: "Checkbox",
      label: "Insurance policy",
      stateKey: "isInsurance",
      disabled: ![1, 2, 8].includes(_userType),
    },

        {
      type: "emptySpace",
      stateKey: "",
    },

    ...(inputStates?.isPfNumber
      ? [
          {
            type: "Textarea",
            label: "PF Number",
            stateKey: "pfNumber",
            disabled: ![1, 2, 8].includes(_userType),
          },
        ]
      : []),
    ...(inputStates?.isEsicNumber
      ? [
          {
            type: "Textarea",
            label: "ESIC Number",
            stateKey: "esicNumber",
            disabled: ![1, 2, 8].includes(_userType),
          },
        ]
      : []),
    ...(() => {
      const pf = inputStates?.isPfNumber;
      const esic = inputStates?.isEsicNumber;
      let count = 0;
      if (pf && esic) count = 2;
      else if (pf || esic) count = 3;
      return Array.from({ length: count }, () => ({
        type: "emptySpace",
        label: "Insurance policy",
        stateKey: "",
      }));
    })(),
    ...(inputStates?.isInsurance
      ? [
          {
            type: "Textarea",
            label: "Company Name",
            stateKey: "insuranceCompanyName",
            disabled: ![1, 2, 8].includes(_userType),
          },
          {
            type: "Textarea",
            label: "Policy Number",
            stateKey: "policyNumber",
            disabled: ![1, 2, 8].includes(_userType),
          },
          {
            type: "DatePicker",
            label: "From Date",
            stateKey: "otherFromDate",
            disabled: ![1, 2, 8].includes(_userType),
          },
          {
            type: "DatePicker",
            label: "To Date",
            stateKey: "validDate",
            disabled: ![1, 2, 8].includes(_userType),
          },
          {
            type: "Autocomplete",
            label: "Dependent Covered",
            stateKey: "dependentCovered",
            options: [
              { id: 0, name: "No" },
              { id: 1, name: "Yes" },
            ],
            valueKey: "id",
            getOptionLabelKey: "name",
            disabled: ![1, 2, 8].includes(_userType),
          },
        ]
      : []),
  ];

  const filterByStateKeys = (fields, state) =>
    fields.reduce((acc, field) => {
      if (state.hasOwnProperty(field.stateKey)) {
        acc[field.stateKey] = state[field.stateKey];

        if (field.stateKey === "dependentCovered") {
          acc["dependentCoveredDetails"] = JSON.stringify(
            beforeCalibrationData,
          );
        }
      }
      return acc;
    }, {});

  const apiRequest = (endpoint, data, id) => {
    const url = `${BASE_URL}${endpoint}`;
    return id !== "0"
      ? axiosWithToken.patch(url + `/${id}`, data)
      : axiosWithToken.post(url, data);
  };

  console.log("inputStates", inputStates);

  const onSubmit = async () => {
    const fieldsToValidate = [
      // Personal Information
      { value: inputStates.employeesCode, label: "Employee Code is required" },
      { value: inputStates.name, label: "Name is required" },
      {
        value: inputStates.permenantAddress,
        label: "Permanent Address is required",
      },
      {
        value: inputStates.currentAddress,
        label: "Current Address is required",
      },
      { value: inputStates.dateOfBirth, label: "Date of Birth is required" },
      {
        value: inputStates.dateOfJoining,
        label: "Date of Joining is required",
      },
      { value: inputStates.contactNumber, label: "Contact Number is required" },
      {
        value: inputStates.alternativeContactNumber,
        label: "Alternative Contact Number is required",
      },
      { value: inputStates.emailAddress, label: "Email Address is required" },
      {
        value: inputStates.officeEmailAddress,
        label: "Office Email Address is required",
      },
      { value: inputStates.gender, label: "Gender is required" },
      { value: inputStates.maritalStatus, label: "Marital Status is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    setDownlaodPdfLoading(true);

    try {
    const personal = filterByStateKeys(inputFields, inputStates);
    const employeeDetails = {
      personal,
      qualification: filterByStateKeys(
        employeeQualificationInputFields,
        inputStates,
      ),
      nominee: filterByStateKeys(employeeNomineeInputFields, inputStates),
      emergency: filterByStateKeys(
        employeeEmergencyDetailsInputFields,
        inputStates,
      ),
      others: filterByStateKeys(onlyForHrInputFields, inputStates),
      document: filterByStateKeys(employeeDocumentInputFields, inputStates),
    };
    // Format only these two fields:
    personal.dateOfBirth = personal.dateOfBirth
      ? moment(personal.dateOfBirth).format("YYYY-MM-DD")
      : null;

    personal.dateOfJoining = personal.dateOfJoining
      ? moment(personal.dateOfJoining).format("YYYY-MM-DD")
      : null;

      const res = await apiRequest("employees", employeeDetails.personal, params.id);
        const employeeId = params.id == 0 ? res.data?.insertId : params.id;

        const detailsMap = [
          {
            endpoint: "employeeQualification",
            data: employeeDetails.qualification,
            id: inputStates?.employeeQualificationId || "0",
          },
          {
            endpoint: "employeeNominee",
            data: employeeDetails.nominee,
            id: inputStates?.employeeNomineeId || "0",
          },
          {
            endpoint: "employeeEmergencyDetails",
            data: employeeDetails.emergency,
            id: inputStates?.employeeEmergencyDetailsId || "0",
          },
          {
            endpoint: "employeeOtherData",
            data: employeeDetails.others,
            id: inputStates?.employeeOtherDataId || "0",
          },
          {
            endpoint: "employeeDocuments",
            data: employeeDetails.document,
            id: inputStates?.employeeDocumentsId || "0",
          },
        ];

        // Run all API calls and wait for them
        await Promise.all(
          detailsMap.map(({ endpoint, data, id }) =>
            apiRequest(endpoint, { ...data, employeeId }, id),
          ),
        );

      // NEW: Handle experience data
      if (inputStates.isExperienced == 2) {
        // Delete removed experience entries
        if (deletedExperienceIds.length > 0) {
          await Promise.all(
            deletedExperienceIds.map((id) =>
              axiosWithToken.delete(`${BASE_URL}employeeExperience/${id}`)
            )
          );
        }
        // Save/update experience entries
        await Promise.all(
          experienceData.map((exp) => {
            const expData = {
              companyName: exp.companyName,
              designation: exp.designation,
              fromDate: exp.fromDate ? moment(exp.fromDate).format("YYYY-MM-DD") : null,
              toDate: exp.toDate ? moment(exp.toDate).format("YYYY-MM-DD") : null,
              workExpCertUrl: exp.workExpCertUrl,
              employeeId,
            };
            return apiRequest("employeeExperience", expData, exp.id || "0");
          })
        );
      } else {
        // If fresher, delete all existing experience records
        if (params.id != 0) {
          const existingExp = await fetchQuery(
            `SELECT id FROM employeeExperience WHERE employeeId = ${employeeId}`
          );
          if (existingExp && existingExp.length > 0) {
            await Promise.all(
              existingExp.map((exp) =>
                axiosWithToken.delete(`${BASE_URL}employeeExperience/${exp.id}`)
              )
            );
          }
        }
      }
        setDownlaodPdfLoading(false);

        toast.success(
          params.id !== "0"
            ? "Employees Updated Successfully!"
            : "Employees Created Successfully!",
        );
        if (params.id == 0) {
          setTimeout(() => navigate("/master/employeeMaster"), 1000);
        } else {
          reloadPage();
        }
      } catch (error) {
        setDownlaodPdfLoading(false);
        console.error("Submit error:", error);
      }
  };

  const fetchCountEmployee = async () => {
    const employeeCount = await fetchCountOfTable("employees/count");
    setEmployeeCount(employeeCount);
  };

  const reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  useEffect(() => {
    if (params.id == 0) {
      updateInputObject(
        "employeesCode",
        `${employeeUnicode}${String(employeeCount + 1)}`,
      );
    }
  }, [employeeCount, employeeUnicode, params.id]);

  //   useEffect(() => {
  //   if (params.id == 0 && inputStates?.permenantAddress) {
  //     updateInputObject("currentAddress", inputStates.permenantAddress);
  //   }
  // }, [inputStates?.permenantAddress, params.id]);

  useEffect(() => {
    if (params.id != 0) {
      fetchEmployeesDetails();
    } else {
      fetchCountEmployee();
    }
  }, [params]);

  // NEW: Clear experience data when switching to Fresher
  useEffect(() => {
    if (inputStates.isExperienced == 1) {
      setExperienceData([]);
    }
  }, [inputStates.isExperienced]);

  return (
    <div>
      {/* <EmployeeExcelUpload
        onProcessRow={async (row) => {
          setInputStates(row);
          await new Promise((r) => setTimeout(r, 300));
          await onSubmit();
        }}
      />
      <br /> */}

      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Employee" : `Update Employee `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Qualification
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeQualificationInputFields}
      />
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Experience
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeExperienceInputFields}
      />
      <br />

      {/* NEW: Experience entries for multiple work experience */}
      {inputStates?.isExperienced === 2 && (
        <>
          <SaveAndUpdate
            label="Add Experience"
            onClick={() => {
              setExperienceData([
                ...experienceData,
                {
                  companyName: "",
                  designation: "",
                  fromDate: "",
                  toDate: "",
                  workExpCertUrl: "",
                },
              ]);
            }}
          />
          <br />
          <br />

          {experienceData.map((exp, index) => (
            <div key={index} style={{ marginBottom: "20px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                <Text variant="h5" bold>Experience {index + 1}</Text>
                {experienceData.length > 1 && (
                  <CancelButton
                    label="Remove"
                    onClick={() => {
                      if (exp.id) {
                        setDeletedExperienceIds([...deletedExperienceIds, exp.id]);
                      }
                      setExperienceData(experienceData.filter((_, i) => i !== index));
                    }}
                  />
                )}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                <TextFields
                  label="Company Name *"
                  value={exp.companyName || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].companyName = e.target.value;
                    setExperienceData(newData);
                  }}
                  multiline
                  minRows={1}
                  maxRows={10}
                />
                <TextFields
                  label="Designation *"
                  value={exp.designation || ""}
                  onChange={(e) => {
                    const newData = [...experienceData];
                    newData[index].designation = e.target.value;
                    setExperienceData(newData);
                  }}
                  multiline
                  minRows={1}
                  maxRows={10}
                />
                <DateInput
                  label="From Date *"
                  value={exp.fromDate || ""}
                  onChange={(date) => {
                    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                    const newData = [...experienceData];
                    newData[index].fromDate = formattedDate;
                    setExperienceData(newData);
                  }}
                />
                <DateInput
                  label="To Date *"
                  value={exp.toDate || ""}
                  onChange={(date) => {
                    const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                    const newData = [...experienceData];
                    newData[index].toDate = formattedDate;
                    setExperienceData(newData);
                  }}
                />
                <UploadButton
                  label=""
                  tooltipLabel="Work Experience Certificate"
                  downloadFile={true}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file && /[&#$*]/.test(file.name)) {
                      toast.warning("File name contains special characters. Please rename the file and upload again.");
                      return;
                    }
                    const data = new FormData();
                    data.append("fileToUpload", file);
                    axiosWithToken
                      .post(BASE_URL + `fileUpload/fileUpload.php`, data)
                      .then((res) => {
                        if (res.status == 200) {
                          const newData = [...experienceData];
                          newData[index].workExpCertUrl = res.data;
                          setExperienceData(newData);
                          toast.success("File Uploaded Successfully!");
                        }
                      })
                      .catch(() => toast.error("Something went wrong"));
                  }}
                  outline={false}
                  fileUrl={exp.workExpCertUrl}
                  showFile={true}
                  onRemove={() => {
                    const newData = [...experienceData];
                    newData[index].workExpCertUrl = null;
                    setExperienceData(newData);
                  }}
                />
              </div>
            </div>
          ))}
          <br />
        </>
      )}

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Nominee
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeNomineeInputFields}
      />
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Emergency Details
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeEmergencyDetailsInputFields}
      />
      <br />

      <hr />
      <br />
      <Text variant="h3" bold className="text-blue-600">
        Document
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={employeeDocumentInputFields}
      />
      <br />

      <hr />
      <br />

      <Text variant="h3" bold className="text-blue-600">
        Only For HR
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={onlyForHrInputFields}
      />
      <br />

      {inputStates?.dependentCovered == 1 && (
        <>
          <EditableTable
            initialColumns={initialColumns}
            data={beforeCalibrationData}
            setData={setBeforeCalibrationData}
            srNo
            deletedRowIds={deletedRowIds}
            setDeletedRowIds={setDeletedRowIds}
            name="Dependent"
          />
          <br />
        </>
      )}

      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {/* {(permissions.save || permissions.allAccess) && ( */}
        <SaveAndUpdate
          id="btn-add-outline"
          label={params.id == 0 ? "Save" : "Update"}
          onClick={onSubmit}
        />
        {/* )} */}
      </div>
      {downloadPdfloading && <LoaderModal loading={downloadPdfloading} />}
    </div>
  );
};

export default EditEmployeeMaster;
